import OkC from "shared/util/OkcApi";

// CUSTOM functions
// these are complicated enough to warrant their own file

import uploadPhotoURL from "./uploadPhotoURL";
import uploadPhotoFile from "./uploadPhotoFile";
import uploadPhotoDetails from "./uploadPhotoDetails";

export {
	uploadPhotoURL,
	uploadPhotoFile,
	uploadPhotoDetails,
};


// Simple API wrappers
// make it a tiny bit easier to use the api.
// if it's not just returning an OkC function, put it in a new file.

/*
 * Set the user's photos to this order.
 *
 * @param {object} params - An object with the required keys:
 *  - photos (array of objects containing:)
 *		- picid
 *		- caption
 *		- ordinal
 *
 * @return {Promise}
 */
export function setPhotoOrder(photos) {
	return OkC.put("/profile/me/photos", {
		data: { photos },
	});
}

export function getFacebookAlbumPhotos({ id, limit = 20, offset = 0 }) {
	return OkC.post("/social/fb", {
		data: {
			path: `/${id}/photos`,
			params: {
				fields: "id,source,width,height,created_time,likes.limit(500){id}",
				limit,
				offset,
			},
		},
	});
}

export function deletePhoto(id) {
	return OkC.delete(`/profile/me/photos/${id}`);
}



// WEBPACK FOOTER //
// ./src/shared/util/PhotoUpload/index.js